import React from 'react'
import { Col, Label,Row } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalViewExamsQuoter = (props) => {

    const {
        modalViewExamsP, toggleModalViewExams, viewExamsProfile,
    } = props;

    return (
        <Dialog 
         header="Exámenes que conforman el Perfil"
         visible={modalViewExamsP}
         headerStyle={{
            backgroundColor: '#0d3b59',
            color: 'white',
            fontWeight: 'bold',
        }}
       pt={{
            header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
            headerIcon: { style: { color: 'white' } },
        }}
            className="pt-0 custom-dialog-img"

        onHide={toggleModalViewExams}
        footer={null}
      
        >
           
                <Row className='m-t-10'>                    
                    <Col sm="12" md="12" lg="12" xl="12">
                        <ul className='cardExam-content'>
                            {
                                viewExamsProfile.length === 0
                                ?
                                    <div>
                                        <br />
                                        <Label>No hay examenes para el perfil seleccionado</Label>
                                    </div>
                                :
                                    <div>
                                        {
                                            viewExamsProfile.map( (obj, index) => {
                                                return (
                                                    <li key={'exam-'+index}>
                                                        <p><img alt="flask" className="img-fluid text-info mr-2" src={require("../../assets/images/typeService.svg")} style={{ width: "30px", height: "30px" }} />&nbsp;&nbsp;{obj.name}</p>
                                                    </li>
                                                )
                                            })
                                        }
                                    </div>
                            }
                        </ul>
                    </Col>
                </Row>
            
        </Dialog>
    )
}
